if($('.in-kosik, .in-cart').length){

  function mhpridatslevu(){
    $('.cart-table tr').each(function(){
      var finddostupnost = $(this).find('.p-availability').html();
      var findcenazakus = $(this).find('.p-price.p-cell').html();
      var findptotal = $(this).find('.p-total');
      var findpname = $(this).find('.p-name');
      $(findpname).append('<span class="dostupnostuceny">'+finddostupnost+'</span>');
      $(findptotal).prepend('<span class="cenazaks">'+findcenazakus+'</span>');
    })
    $(".in-kosik h4:contains('"+darky_slevy+"')").remove();
    $('<div class="kupon-odkaz">'+slevovypoukaz+'</div>').prependTo(".in-kosik .discount-coupon, .in-cart .discount-coupon");
    $('.kupon-odkaz').click( function() { $(".discount-coupon").toggleClass("viditelny");} );
    $('.discount-coupon').each(function(){
        if($(this).find('.applied-coupon').length){
            $(this).addClass('havecupon');
        }
    })
  };
  mhpridatslevu()
document.addEventListener('ShoptetDOMCartContentLoaded', function () {
mhpridatslevu();
  });
}         
if($('.in-krok-2').length){
    $("#checkoutContent .co-contact-information").find(".form-group label[for=login]").parent().addClass("login-form-group");
    $(".login-form-group").prependTo("#checkoutContent .co-contact-information");
    $('#shipping-address').appendTo('.co-box.co-billing-address');
     $('.co-box.co-box-additional').appendTo('.co-box.co-billing-address')
  
  }
  function exist(e){if($(e).length)return!0};

  
    
  $(document).on("ShoptetDOMAdvancedOrderLoaded",function(){
      $(".advanced-order .h1:not(.advanced-order-suggestion)").text(addtocart),
      $(".advanced-order .btn.btn-conversion").text(tocart),
      exist(".advanced-order .h1.advanced-order-suggestion")&&$(".advanced-order .h1.advanced-order-suggestion").text(castonakupuji),
      $(".advanced-order .extras-wrap").prepend('<div class="extra step-back"><span class="btn inline-block btn-back" href="#" id="mhclose">'+backtoshop+'</span></div>'),
      
      $('body').on("click","#mhclose",function(){
          $("div#colorbox button#cboxClose").click();
      })
      $.colorbox.resize()
  })

  if($('.in-dekujeme').length){
    $('.cart-table tr').each(function(){
      var findcenazakus = $(this).find('.p-quantity').html();
      var findptotal = $(this).find('.p-price');
      $(findptotal).prepend('<span class="cenazaks">'+findcenazakus+'</span>');
    })
  }
  exist(".in-kosik, .in-cart")&&(
    $(document).on("ready ShoptetDOMCartContentLoaded",function(){
      if($(".cart-empty").length){
      $("body").addClass("prazdny-kosik"), 
      $('.cart-empty .cart-row').append('<div class="cartisempty"><p>'+popisprazdnykosik+'</p><div class="text-center"><a href="/nmn-60-tablet/" class="btn btn-white plus">DOZVĚDĚT SE VÍCE</a></div>')
  
    }
    })
  )